import { Platform } from 'react-native';
import * as FileSystem from 'expo-file-system';

export async function downloadAndConvertToBase64(imageUrl?: string | null) {
  if (!imageUrl) {
    return '';
  }

  try {
    if (Platform.OS === 'web') {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    }

    const documentDirectory = (FileSystem as any).documentDirectory;
    if (!documentDirectory) {
      throw new Error('documentDirectory is not available');
    }

    const downloadResult = await FileSystem.downloadAsync(
      imageUrl,
      documentDirectory + 'image.jpg'
    );

    const base64Result = await FileSystem.readAsStringAsync(downloadResult.uri, {
      encoding: 'base64',
    });

    return `data:image/jpg;base64,${base64Result}`;
  } catch (error) {
    console.error('Error downloading and converting image:', error);
  }

  return '';
}

